import {
    formatNumberByLocale,
    formatUniversalUnitByLocale,
    type Locale,
} from '@/utils/localeFormatters';

import type { MetricAxisSpec } from './axisTypes';
import { DEFAULT_AXIS_DECIMALS } from './constants';

/** Formats a value with its axis unit, or plainly when the axis has no unit. */
export function formatAxisValue(
    value: number,
    axis: MetricAxisSpec | undefined,
    locale: Locale,
    decimals: number,
    target: 'tick' | 'tooltip'
): string {
    if (axis?.format) {
        return axis.format(value, target);
    }

    if (axis?.unit) {
        return formatUniversalUnitByLocale(value, axis.unit, locale, decimals);
    }

    return formatNumberByLocale(value, locale, decimals);
}

/** Decimals for this axis' tick labels. */
export function resolveTickDecimals(axis: MetricAxisSpec): number {
    return axis.tickDecimals ?? DEFAULT_AXIS_DECIMALS;
}

/**
 * Decimals for a value plotted on this axis, most specific first: the series'
 * own override, then the axis' `valueDecimals`, then the shared default.
 */
export function resolveValueDecimals(
    axis: MetricAxisSpec | undefined,
    seriesDecimals: number | undefined
): number {
    return seriesDecimals ?? axis?.valueDecimals ?? DEFAULT_AXIS_DECIMALS;
}
